import { BasicScrollView } from "@/components/BasicScrollView";
import Head from 'expo-router/head';
import Footer from '@/components/Footer';
import * as TextBlocks from '@/utilities/TextBlocks';
import { MarkdownBlock } from '@/utilities/TextBlocks';
import { Meta } from "@/components/Meta";

export default function Terms() {
  return (
    <BasicScrollView center={false}>
      <Meta title={"Terms of service"} />
      <MarkdownBlock heading="Terms of Service" markdown={TextBlocks.TERMS_AND_CONDITIONS_MARKDOWN} />
      <MarkdownBlock heading="Community Guidelines" markdown={TextBlocks.COMMUNITY_GUIDELINES_MARKDOWN} />
      <MarkdownBlock heading="Refunds policy" markdown={TextBlocks.REFUNDS_MARKDOWN} />
      <MarkdownBlock heading="Child Sexual Abuse and Exploitation" markdown={TextBlocks.CHILD_SEXUAL_ABUSE_AND_EXPLOITATION_POLICY_MARKDOWN} />
      <MarkdownBlock heading="Anti-human trafficking & content compliance policy" markdown={TextBlocks.HUMAN_TRAFFICKING_POLICY_MARKDOWN} />
      <MarkdownBlock heading="Complaints policy" markdown={TextBlocks.COMPLAINTS_MARKDOWN} />
      <MarkdownBlock heading="Appeals policy" markdown={TextBlocks.APPEALS_MARKDOWN} />
      <MarkdownBlock heading="Data Processing Agreement" markdown={TextBlocks.DATA_PROCESSING_AGREEMENT_MARKDOWN} />
      <MarkdownBlock heading="Privacy Policy" markdown={TextBlocks.PRIVACY_POLICY_MARKDOWN} />
      <Footer />
    </BasicScrollView>
  );
}
